import React, { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import InvoiceItems from "./InvoiceItems";
import { FaFilePdf, FaRegCreditCard } from "react-icons/fa6";
import { ConvertPriceToString, datePlus7DaysYYYYMMDDHHmmss, dateToYYYYMMDD } from "../../../Helpers/CustomConverter";
import { useInvoices } from "../../../Providers/InvoicesProvider";
import useDownloadFinanceDocuments from "../../../Hooks/useDownloadFinanceDocuments";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { formatDocumentNumber } from "../../../Helpers/DocumNumHelper";
import { useAuth } from "../../../Providers/AuthProvider";
import { useParams } from "../../../Providers/ParamsProvider";
import { Licenses } from "../../../Data/Licenses.ts";
import { OverlayTrigger, Popover } from "react-bootstrap";
import PaymentWithValueModal from "../../Components/Modals/PaymentWithValueModal";
import usePaymentFlow from "../../../Hooks/usePaymentFlow";

const Invoice = ({ invoice, setShowNoEInvoiceModal }) => {
  const { createPaymentAndRedirect } = usePaymentFlow()
  const { authState } = useAuth()
  const [ordersValue, setOrdersValue] = useState(0);
  const { handleGetArchiveInvoiceItems } = useInvoices();
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [showItems, setShowItems] = useState(false);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const { downloadFinanceDocument, isLoading } = useDownloadFinanceDocuments();
  const { license } = useParams();
  const [showMessageAskToPay, setShowMessageAskToPay] = useState(false)

  function reverseDate(date) {
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
  }

  function reverseDateShort(date) {
    return `${date.substring(4, 6)}-${date.substring(2, 4)}-20${date.substring(0, 2)}`
  }

  function countPayDays() {
    const docDateToCompare = new Date(invoice.docDate);
    const payDateToCompare = new Date('20' + invoice.paidDate.substring(0, 2) + '-' + invoice.paidDate.substring(2, 4) + '-' + invoice.paidDate.substring(4, 6));

    const differenceInTime = new Date(payDateToCompare.getFullYear(), payDateToCompare.getMonth(), payDateToCompare.getDate()) - new Date(docDateToCompare.getFullYear(), docDateToCompare.getMonth(), docDateToCompare.getDate()); // Wynik w milisekundach
    const differenceInDays = Math.round(differenceInTime / (1000 * 60 * 60 * 24)); // Przeliczenie na dni

    return differenceInDays - invoice.payTerm;
  }

  useEffect(() => {
    if (showItems) {
      handleGetItems()
    }
  }, [showItems])

  const handleGetItems = async () => {
    setIsLoadingItems(true)
    const items = await handleGetArchiveInvoiceItems(invoice)
    setInvoiceItems(items)
    setIsLoadingItems(false)
  }

  const handleDownloadPdf = () => {
    if ((authState.user && authState.user.customerInfo && authState.user.customerInfo[0].isEInvoiceConsent) || (authState.user && authState.user.isOperator)) {
      downloadFinanceDocument(invoice.nrDoc, invoice.docDate, invoice.oddzial)
      return
    }
    else {
      setShowNoEInvoiceModal(true)
    }
  }

  const handleAskToPayModal = async (amountToPay) => {
    setShowMessageAskToPay(false)
    if (amountToPay) {
      await createPaymentAndRedirect({
        orderId: `${formatDocumentNumber(invoice.nrDoc, invoice.docDate, invoice.oddzial).replaceAll('/', '-')}`,
        docOrderId: invoice.nrDoc,
        docOrderDate: dateToYYYYMMDD(invoice.docDate),
        siteId: invoice.oddzial,
        userId: authState.user.userId,
        custId: authState.custId,
        amount: amountToPay,
        customerEmail: authState.user.email,
        paymentTitle: `Dok. nr ${formatDocumentNumber(invoice.nrDoc, invoice.docDate, invoice.oddzial)}`,
        gateWayId: -1,
        paymentExpDate: datePlus7DaysYYYYMMDDHHmmss()
      })
    }
  }

  const popoverToPay = <Popover id="popover-basic">
    <Popover.Body className="text-center">
      <span className='primary-accent-color-text'>Opłać dokument</span>
    </Popover.Body>
  </Popover>

  return (
    <>
      <PaymentWithValueModal
        show={showMessageAskToPay}
        onHide={handleAskToPayModal}
        docNo={formatDocumentNumber(invoice.nrDoc, invoice.docDate, invoice.oddzial)}
        valueToPay={invoice.value - invoice.paid}
      />

      <tr className="hoverable-row">
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{license == Licenses.TgInstalacje ? invoice.seller.toLocaleLowerCase().replace('tg instalacje sp. z o.o. ', '').toLocaleUpperCase() : invoice.seller}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{invoice.docName}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{formatDocumentNumber(invoice.nrDoc, invoice.docDate, invoice.oddzial)}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {reverseDate(invoice.docDate.substring(0, invoice.docDate.indexOf("T")))}
        </td>
        <td style={{ alignContent: "center", textAlign: "left", fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
          {ConvertPriceToString(invoice.value, null)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
          {ConvertPriceToString(invoice.paid, null)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {invoice.paidDate.toString().trim().length > 0 && reverseDateShort(invoice.paidDate)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {invoice.value - invoice.paid == 0 || -invoice.value - invoice.paid == 0 ? countPayDays() : ''}
        </td>
        <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
          {invoice.comments}
        </td>
        <td>
          {(parseFloat(invoice.value) - parseFloat(invoice.paid)) > 0 ?
            (
              <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverToPay}>
                <div className='element-pointer'>
                  <FaRegCreditCard size={20} onClick={() => setShowMessageAskToPay(true)} />
                </div>
              </OverlayTrigger>)
            :
            (null)
          }

        </td>
        <td style={{ alignContent: "center", textAlign: "center" }}>
          {isLoading ? <LoadingSpinner width={2} height={2} bubble={false} /> : <FaFilePdf style={{ cursor: "pointer" }} color="black" size={20} onClick={() => handleDownloadPdf()} />}
        </td>
      </tr>
      {showItems && (
        <tr>
          <td colSpan="10" style={{ padding: 10 }}>
            <InvoiceItems items={invoiceItems} isLoading={isLoadingItems} />
          </td>
        </tr>
      )}
    </>
  );
};

export default Invoice;
